<template lang="html">
  <div>
    <h3 class="card-title">Valuation {{ refNo }} - {{ page }}</h3>
    <div
      class="inline pull-right header-tools"
      style="position:absolute; right: 0;"
    >
      <a
        href="javascript:;"
        class="btn btn-icon"
        title="Job Diary"
        v-b-modal.job-diary
      >
        <i class="fa fa-file-text" aria-hidden="true"></i>
      </a>

      <a
        href="javascript:;"
        class="btn btn-icon"
        title="File Dump"
        v-b-modal.file-dump
      >
        <i class="fa fa-files-o" aria-hidden="true"></i>
      </a>
    </div>
    <!-- job diary -->
    <b-modal
      id="job-diary"
      size="lg"
      title="Job Diary"
      hide-footer
      ref="jobDiaryModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <form @submit.prevent="addNote">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Note</label>
              <textarea
                class="form-control"
                v-model="note"
                rows="4"
                required
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button
              type="submit"
              class="btn btn-primary pull-right"
              :disabled="valuation.isLocked == true"
            >
              Add Note
            </button>
            <button
              type="button"
              class="btn btn-secondary pull-right"
              style="margin-right: 5px;"
              @click="closeJobDiaryModal"
            >
              Close
            </button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-md-12">
          <hr />
        </div>
      </div>
      <span v-for="(item, index) in valuation.note" :key="index">
        <div class="row">
          <div class="col-6 col-md-8">
            <h6 v-if="typeof item.user !== 'undefined'">
              {{ item.user.name }}
            </h6>
          </div>
          <div class="col-6 col-md-4">
            <h6 class="pull-right">{{ item.created }}</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p>{{ item.note }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <hr />
          </div>
        </div>
      </span>
    </b-modal>
    <!-- file dump -->
    <b-modal
      id="file-dump"
      size="lg"
      title="File Dump"
      hide-footer
      ref="fileDumpModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="row">
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-icon btn-border pull-right"
            title="Upload File"
            @click="upload = !upload"
            :disabled="valuation.isLocked == true"
          >
            <i class="fa fa-cloud-upload" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <span v-if="upload">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">File</label>
              <div class="input-group">
                <input
                  type="file"
                  id="files"
                  class="form-control-file"
                  ref="files"
                  multiple
                  v-on:change="handleFiles()"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="isError">
          <div class="col-md-12">
            <div class="alert alert-danger" role="alert">
              The file {{ error.name }} (Type: {{ error.type }}, Size:
              {{ error.size }}MB) exceeds size limit of 25MB!
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <ul>
              <li v-for="(file, key) in files" :key="key">
                {{ file.name }}
                <span class="success-container" v-if="file.id > 0"
                  >Success</span
                >
                <span class="remove-container" v-else>
                  <button
                    type="button"
                    class="btn btn-icon btn-sm"
                    v-on:click="removeFile(key)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="row" style="margin-bottom: 15px;">
          <div class="col-md-12">
            <button
              type="button"
              class="btn btn-primary pull-right"
              v-on:click="submitFiles()"
            >
              Upload
            </button>
            <!-- v-show="files.length > 0" -->
          </div>
        </div>
      </span>
      <div class="row">
        <div class="col-md-12">
          <!-- <button type="button" class="btn btn-icon btn-border pull-right" style="position:absolute; bottom: 23px; right:13px;">
            <i class="fa fa-cloud-upload" aria-hidden="true"></i>
          </button>-->
          <div class="form-group">
            <label class="form-label">Pinned Files</label>
            <hr />
          </div>
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-6"
          v-for="(item, index) in valuation.file"
          :key="index"
        >
          <div class="file-container">
            <div class="row">
              <div class="col-3 col-md-3 col-lg-2">
                <div class="file-type-container">
                  <i class="fa fa-file-pdf-o fa-3x" aria-hidden="true"></i>
                </div>
              </div>
              <div class="col-6 col-md-7 col-lg-8 file-details">
                <p>
                  <a
                    :href="rootUrl + 'serve-file?link=' + item.file_url"
                    target="_blank"
                    >{{ item.file_name }}</a
                  >
                </p>
                <p>{{ item.created }}</p>
              </div>
              <div class="col-3 col-md-2 col-lg-2">
                <div class="file-pin-container">
                  <a
                    href="javascript:;"
                    @click.prevent="pinFile(item, false)"
                    title="Pin or Unpin"
                  >
                    <i
                      class="fa fa-thumb-tack pull-right"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <hr />
        </div>
      </div>

      <div class="row">
        <div class="col-md-9">
          <div class="form-group">
            <label class="form-label">Search Files</label>
            <div class="input-icon mb-3">
              <input
                type="text"
                class="form-control"
                placeholder="Search for..."
                v-model="fileSearch"
              />
              <span class="input-icon-addon">
                <i class="fe fe-search"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="form-label">&nbsp;</label>
            <button
              type="button"
              class="btn btn-secondary pull-left"
              style="margin-right:5px;"
              @click="resetFileSearch"
            >
              Reset
            </button>
            <button
              type="button"
              class="btn btn-primary pull-left"
              @click="searchFile"
            >
              Search
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <hr />
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-6"
          v-for="(item, index) in unmappedFiles"
          :key="index"
        >
          <div class="file-container">
            <div class="row">
              <div class="col-3 col-md-3 col-lg-2">
                <div class="file-type-container">
                  <i class="fa fa-file-o fa-3x" aria-hidden="true"></i>
                </div>
              </div>
              <div class="col-6 col-md-7 col-lg-8 file-details">
                <p>
                  <a
                    :href="rootUrl + 'serve-file?link=' + item.file_url"
                    target="_blank"
                    >{{ item.file_name }}</a
                  >
                </p>
                <p>{{ item.created }}</p>
              </div>
              <div class="col-3 col-md-2 col-lg-2">
                <div class="file-pin-container">
                  <a
                    href="javascript:;"
                    @click.prevent="pinFile(item, true)"
                    title="Pin or Unpin"
                  >
                    <i
                      class="fa fa-thumb-tack pull-right"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="unmappedFiles.length == 0">
          <p class="text-center">No files found!</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-secondary pull-right"
            style="margin-right: 5px;"
            @click="closeFileDumpModal"
          >
            Close
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="progress-modal"
      centered
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      body-class="progress-modal-body"
      size="lg"
      hide-footer
      ref="progressModal"
    >
      <div class="d-flex justify-content-center">
        <div class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-success" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-danger" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-warning" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-info" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-light" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-dark" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable */
import Swal from "sweetalert2";
export default {
  props: {
    refNo: {
      required: true,
    },
    valuation: {
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      note: "",
      upload: false,
      files: [],
      error: {},
      isError: false,
      fileSearch: "",
      unmappedFiles: [],
    };
  },
  methods: {
    getUnmappedFiles() {
      //this.$refs.progressModal.show();
      this.$http.get(this.rootUrl + "file/unmapped", this.corsConfig).then(
        (res) => {
          this.refreshToken(res);
          this.unmappedFiles = res.data;
          //this.$refs.progressModal.hide();
        },
        (err) => {
          this.$snotify.error(err.response.data.message, "Valuation", {
            timeout: 4000,
            showProgressBar: false,
            position: "rightTop",
          });
          //this.$refs.progressModal.hide();
        }
      );
    },
    resetFileSearch() {
      this.fileSearch = "";
      this.searchFile();
    },
    searchFile() {
      //this.$refs.fileDumpModal.hide();
      //this.$refs.progressModal.show();
      this.$http
        .post(this.rootUrl + "file/search-valuation", {
          text: this.fileSearch,
          valuation_id: this.valuation.id,
        })
        .then(
          (res) => {
            this.refreshToken(res);
            this.unmappedFiles = res.data;
            //this.$refs.progressModal.hide();
            //this.$refs.fileDumpModal.show();
          },
          (err) => {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
            //this.$refs.progressModal.hide();
          }
        );
    },
    closeFileDumpModal() {
      // Swal({
      //   title: "Are you sure to cancel and discard changes?",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonText: "Yes",
      //   cancelButtonText: "Cancel"
      // }).then(result => {
      //   if (result.value) {
      this.upload = false;
      this.resetFile();
      this.$refs.fileDumpModal.hide();
      //   }
      // });
    },
    closeJobDiaryModal() {
      // Swal({
      //   title: "Are you sure to cancel and discard changes?",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonText: "Yes",
      //   cancelButtonText: "Cancel"
      // }).then(result => {
      //   if (result.value) {
      this.note = "";
      this.$refs.jobDiaryModal.hide();
      //   }
      // });
    },
    addNote() {
      //this.$parent.$refs.progressModal.show();
      this.$http
        .post(this.rootUrl + "valuation-note", {
          note: this.note,
          valuation_id: this.valuation.id,
        })
        .then(
          (res) => {
            this.refreshToken(res);
            //this.valuation = res.data;
            // if (this.valuation.hdb == null) {
            //   this.valuation.hdb = {};
            // }
            this.$emit("valuationUpdated", res.data);
            this.note = "";
            // this.$parent.$refs.progressModal.hide();
          },
          (err) => {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
            //this.$parent.$refs.progressModal.hide();
          }
        );
    },
    handleFiles() {
      const uploadedFiles = this.$refs.files.files;

      for (let i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
      //this.getImagePreviews();
    },
    removeFile(key) {
      this.files.splice(key, 1);
      this.isError = false;
      // this.getImagePreviews();
    },
    submitFiles() {
      //for (let i = 0; i < this.files.length; i++) {
      if (typeof this.files[0] === "undefined") {
        return;
      }
      this.$refs.fileDumpModal.hide();
      this.$refs.progressModal.show();
      const fileSize = this.files[0].size / 1024 / 1024;
      if (fileSize >= 25) {
        this.isError = true;
        this.error.size = fileSize.toFixed(2);
        this.error.name = this.files[0].name;
        this.error.type = this.files[0].type;
        //this.loadData(this.valuation.id, true);
        return;
      }
      const formData = new FormData();
      formData.append("file", this.files[0]);
      formData.append("valuation_id", this.valuation.id);
      this.$http
        .post(this.rootUrl + "valuation-file-upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(
          (res) => {
            this.refreshToken(res);
            this.valuation.file = res.data;
            this.upload = false;
            this.$refs.progressModal.hide();
            this.$refs.fileDumpModal.show();
          },
          (err) => {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
            this.$refs.progressModal.hide();
            this.$refs.fileDumpModal.show();
          }
        );
      // }

      this.resetFile();
      //this.$refs.fileUploadModal.hide();
    },
    resetFile() {
      this.files = [];
      this.isError = false;
      const input = this.$refs.files;
      if (typeof input !== "undefined") {
        input.type = "text";
        input.type = "file";
      }
    },
    pinFile(item, is_pinned) {
      //this.$refs.fileDumpModal.hide();
      //this.$refs.progressModal.show();
      this.$http
        .post(this.rootUrl + "pin-file", {
          id: item.id,
          is_pinned: is_pinned,
          valuation_id: this.valuation.id,
        })
        .then(
          (res) => {
            this.refreshToken(res);
            this.valuation.file = res.data.valuationFile;
            this.unmappedFiles = res.data.unmapped;
            //this.$refs.progressModal.hide();
            //this.$refs.fileDumpModal.show();
          },
          (err) => {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
            //this.$refs.progressModal.hide();
          }
        );
    },
  },
  mounted() {
    this.getUnmappedFiles();
  },
};
</script>
<style scoped>
.card-title {
  display: inline-block;
}
</style>
